import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
} from "react";
import axios from "axios";

import { useParams, Link } from "react-router-dom";
import Select from "react-select";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import jsPDF from "jspdf";
import JsBarcode from "jsbarcode";

import * as XLSX from "xlsx";

import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "../../../assets/css/customersummary.css";
import "jspdf-autotable";
import Moment from "moment";

//--------Material React Table------//
import { MaterialReactTable } from "material-react-table";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

const currentDate = new Date();
const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const month = monthNames[currentDate.getMonth()]; // add 1 to get month value from 1 to 12
const hours = currentDate.getUTCHours();
const minutes = currentDate.getUTCMinutes();

const CustomerBalanceDetail = (props) => {
  const gridRef = useRef();
  const token = localStorage.getItem("Token");
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [totalbalance, setTotalBalance] = useState(0);

  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState("");

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  const ITEMS_PER_PAGE = 10;

  const barcodeRefs = useRef([]);
  let index = 0;
  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 20,
    fontSize: 15,
    zeroFill: 10,
  });

  //Function to generate barcode
  const generateBarcodes = () => {
    barcodeRefs.current.forEach((barcodeRef, index) => {
      console.log("barcodeRefs", barcodeRefs);
      var g = document.getElementsByTagName(barcodeRef);
      const barcodeValue = paramObject.id;
      console.log("barcodeValue", barcodeValue);
      const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        width: data.width,
        height: data.height,
        fontSize: data.fontSize,
        displayValue: true,
        fontoptions: "bold",
        textAlign: "center",
        font: "monospace",
        textPosition: "bottom",
        textMargin: 2,
        margin: 10,
        marginTop: undefined,
        marginBottom: undefined,
        marginLeft: undefined,
        marginRight: undefined,
        format: "CODE128",
        valid: () => true,
        background: "#ffffff",
        lineColor: "#000000",
        padding: data.zeroFill,
      });
    });
  };

  //Function for downloading pdf of barcodesheet

  //Function for download

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
  };

  //Function for lookup receipt
  const paramObject = useParams();

  const apicall = () => {
    // const fetchData = async () => {
    const columnIndex = columns.findIndex(
      (column) => column.accessorKey === sorting[0]?.id
    );
    console.log(
      JSON.stringify(columnFilters) + " columnFilters | ",
      globalFilter + " globalFilter | ",
      pagination.pageIndex + " pagination.pageIndex | ",
      pagination.pageSize + " pagination.pageSize | ",
      columnIndex,
      sorting[0]?.id,
      sorting[0]?.desc === undefined
        ? "desc"
        : (sorting[0]?.desc === true ? "desc" : "asc") + " sorting | ",
      startdate + " startdate | ",
      enddate + " enddate",
      "api Call payload"
    );

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters;

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/customerbalancedetail?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
          pagination.pageSize
        }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
          globalFilter === undefined ? "" : globalFilter
        }&startdate=${startdate}&enddate=${enddate}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData, "res======>");
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
          setData(res.data.ResponseData);
          setRowCount(res.data.ResponseData[0].TotalRecord);
          //   barcodeRefs.current = responseData;
        }
        setLoading(false);
      })
      .catch((err) => {
        setIsError(true);
        console.log(err);
        setLoading(false);
        return;
      });

    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
    // }
    // fetchData();
  };

  useEffect(() => {
    apicall();
  }, [
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    // startdate,
    // enddate,
  ]);

  // useEffect(()=>{
  //   axios
  //   .get(
  //     `${config.reportsBaseUrl}/reports/customerbalancedetail?startdate=&enddate=`,
  //     {
  //       headers: {
  //         "Content-Type": "application/json;charset=UTF-8",
  //         "Access-Control-Allow-Origin": "*",
  //         Authorization: token,
  //       },
  //     }
  //   )
  //   .then((res) => {
  //     console.log("res======>", res);
  //     console.log(res.data.ResponseData);
  //     if (res.data.ResponseCode === "SUCCESS") {
  //       setResponseData(res.data.ResponseData);
  //       setData(res.data.ResponseData);

  //       console.log("11", responseData);
  //       //   barcodeRefs.current = responseData;
  //     }
  //     setLoading(false);
  //   })
  //   .catch((err) => {
  //     console.log(err);
  //     setLoading(false);
  //   });
  // },[])

  console.log(responseData, "responseData168");
  useEffect(() => {
    generateBarcodes();
    console.log("barcodeRefs", barcodeRefs);
    // setLoading(true);

    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        // setLoading(false);
        return res;
      });
  }, []);

  //Function for export excel

  // to calculate the total
  const calculateTotalSum = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Amount);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalSum(sum);
  };

  // to calculate the total
  const calculateTotalBalance = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Balance);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalBalance(sum);
  };

  useEffect(() => {
    calculateTotalSum();
    calculateTotalBalance();
  }, [responseData]);

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };

  const columnTypes = useMemo(() => {
    return {
      number: {
        editable: true,
        // editing works with strings, need to change string to number
        valueParser: (params) => {
          return parseInt(params.newValue);
        },
        aggFunc: "sum",
      },
    };
  }, []);

  // const columnDefs = [
  //   {headerName: "CustomerName",field: 'CustomerName',minWidth: 180,width: 130,enableRowGroup: true,rowGroup: true,hide: true},

  //   {headerName: "CompanyName",field: 'CompanyName',width: 180,enableRowGroup: true},
  //   {headerName: "Date",
  //   field: "Date",
  //   enableValue: true,
  //   suppressMenu: true,
  //   enableRowGroup: true,
  //   minWidth: 90,
  //   filter: "agNumberColumnFilter",

  //   width: 120,
  //   valueGetter: ({ data }) =>{
  //     // Parse the string OpenBalance and return as an integer
  //     if(data?.Date!==undefined){

  //       return Moment(data?.Date).format('DD-MM-YYYY')
  //     }else
  //     return ""
  //   }

  //   },
  //   {headerName: "ModifiedDate",
  //   field: "ModifiedDate",
  //   enableValue: true,
  //   suppressMenu: true,
  //   enableRowGroup: true,
  //   minWidth: 90,
  //   filter: "agNumberColumnFilter",

  //   width: 160,
  //   valueGetter: ({ data }) =>{
  //     // Parse the string OpenBalance and return as an integer
  //     if(data?.ModifiedDate!==undefined){

  //       return data?.ModifiedDate==null ? "--": Moment(data?.ModifiedDate).format('DD-MM-YYYY')
  //     }else
  //     return ""
  //   }

  //   },
  //   {headerName: "CreatedBy",field: 'CreatedBy',width: 130,enableRowGroup: true},
  //   {headerName: "ModifiedBy",field: 'ModifiedBy',minWidth: 180,width: 130,enableRowGroup: true},
  //   {headerName: "Phone",field: 'Phone',width: 130,enableRowGroup: true},
  //   {headerName: "BillingAddress",field: 'BillingAddress',minWidth: 180,width: 130,enableRowGroup: true},
  //   {headerName: "Email",field: 'Email',minWidth: 180,width: 130,enableRowGroup: true},
  //   { headerName: "TransactionType",field: "TransactionType", width:160,enableRowGroup: true },
  //   {headerName: "Terms",field: 'Terms',width: 130,enableRowGroup: true},
  //   {headerName: "VendorMessage",field: 'VendorMessage',width: 170,enableRowGroup: true},
  //   {headerName: "MemoDescription",field: 'MemoDescription',width: 170,enableRowGroup: true},
  //   {headerName: "DeliveryAddress",field: 'DeliveryAddress',width: 170,enableRowGroup: true},
  //   { headerName: "Num",field: "Num",width:120,enableRowGroup: true},
  //   // { field: "Name" },
  //   {headerName: "DueDate",
  //   field: "DueDate",
  //   enableValue: true,
  //   suppressMenu: true,
  //   enableRowGroup: true,
  //   minWidth: 90,
  //   filter: "agNumberColumnFilter",

  //   width: 160,
  //   valueGetter: ({ data }) =>{
  //       // Parse the string OpenBalance and return as an integer
  //       if(data?.DueDate!==undefined){

  //         return Moment(data?.DueDate).format('DD-MM-YYYY')
  //       }else
  //       return ""
  //     }
  //   },

  //   {
  //     headerName: "Amount",
  //     field: "Amount",
  //     width: 170,
  //     enableValue: true,
  //     suppressMenu: true,
  //     filter: "agNumberColumnFilter",
  //     aggFunc: "sum",
  //     suppressAggFuncInHeader: true,

  //     // defaultAggFunc: 'Amount',
  //     enableRowGroup: true,
  //     valueGetter: function (params) {

  //       return parseInt(params.data?.Amount, 10);
  //     },

  //   },
  //   {
  //       headerName: "OpenBalance",
  //       field: "OpenBalance",
  //       width: 170,
  //       enableValue: true,
  //       suppressMenu: true,
  //       filter: "agNumberColumnFilter",
  //       aggFunc: "sum",
  //       enableRowGroup: true,
  //       valueGetter: function (params) {
  //         // Parse the string OpenBalance and return as an integer
  //         return parseInt(params.data.OpenBalance, 10);
  //       },

  //     },
  //   {
  //     headerName: "Balance",
  //     field: "Balance",
  //     width: 200,
  //     enableValue: true,
  //     suppressMenu: true,
  //     enableRowGroup: true,
  //     filter: "agNumberColumnFilter",
  //     aggFunc: "sum",
  //     valueGetter: function (params) {
  //       // Parse the string OpenBalance and return as an integer
  //       return parseInt(params.data.Balance, 10);
  //     },

  //   },
  // ];

  const columns = useMemo(() => [
    {
      header: "CustomerName",
      accessorKey: "CustomerName",
      // enableGrouping: false, //do not let this column be grouped
    },
    {
      header: "CompanyName",
      accessorKey: "CompanyName",
    },
    {
      header: "Date",
      accessorKey: "Date",
      Cell: ({ row }) =>
        moment(row.original.Date).format("MM-DD-YYYY HH:mm:ss"),
    },
    {
      header: "ModifiedDate",
      accessor: "ModifiedDate", // Change accessorKey to accessor
      Cell: ({ row }) => {
        const modifiedDate = row?.original?.ModifiedDate;
        if (
          modifiedDate === "0000-00-00" ||
          modifiedDate === "" ||
          modifiedDate === null
        ) {
          return "";
        }
        return moment(modifiedDate).format("DD-MM-YYYY");
      },
    },
    {
      header: "CreatedBy",
      accessorKey: "CreatedBy",
    },
    {
      header: "ModifiedBy",
      accessorKey: "ModifiedBy",
    },
    {
      header: "Phone",
      accessorKey: "Phone",
    },
    {
      header: "BillingAddress",
      accessorKey: "BillingAddress",
    },
    {
      header: "Email",
      accessorKey: "Email",
    },
    {
      header: "TransactionType",
      accessorKey: "TransactionType",
    },
    {
      header: "Terms",
      accessorKey: "Terms",
    },
    {
      header: "VendorMessage",
      accessorKey: "VendorMessage",
    },
    {
      header: "MemoDescription",
      accessorKey: "MemoDescription",
    },
    {
      header: "DeliveryAddress",
      accessorKey: "DeliveryAddress",
    },
    {
      header: "Num",
      accessorKey: "Num",
    },
    {
      header: "DueDate",
      accessorKey: "DueDate",
      Cell: ({ row }) => moment(row.original.Date).format("DD-MM-YYYY"),
    },
    {
      header: "Amount",
      accessorKey: "Amount",
    },
    {
      header: "OpenBalance",
      accessorKey: "OpenBalance",
    },
    {
      header: "Balance",
      accessorKey: "Balance",
    },
  ]);

  const handleExportRows = (rows) => {
    console.log(
      rows.map((row) => row.original),
      "selected row"
    );
    // csvExporter.generateCsv(rows.map((row) => row.original));

    const workbook = XLSX.utils.book_new();
    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(rows.map((row) => row.original));
    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `CustomerBalanceDetail_.xlsx`);
  };

  // const downloadSlectedRowPDF = (rows) => {
  //   const newData = rows.map((row) => row.original);
  //   console.log(newData, "newData");
  //   setLoading(true);
  //   var doc = new jsPDF("p", "pt", "a4");

  //   // Add the header
  //   let headerElement = document.querySelector("#header");
  //   let clonedHeader = headerElement.cloneNode(true);
  //   clonedHeader.style.fontSize = `10px`;
  //   clonedHeader.style.width = "560px";
  //   clonedHeader.style.margin = "1rem";

  //   let content = "";
  //   let startIndex = 1;
  //   let endIndex = 25;

  //   for (var i = 1; i <= Math.ceil(newData.length / 25); i++) {
  //     if (i == 1) {
  //       clonedHeader.style.marginTop = "2rem";
  //     }
  //     if (i > 1) {
  //       clonedHeader.style.marginTop = "2.5rem";
  //     }
  //     // Printing header
  //     content += " " + clonedHeader.outerHTML;

  //     // Printing table body
  //     content +=
  //       '<table style="font-size: 8px; margin-left: 1rem; margin-top: 2rem; width: 560px; border: 1px solid #f5f5f5">';
  //     content +=
  //       "<thead><tr style='margin-bottom: 5px'>" +
  //       '<th style="padding: 7px;">No</th>' +
  //       '<th style="padding: 7px;">CustomerName</th>' +
  //       '<th style="padding: 7px;">Date</th>' +
  //       '<th style="padding: 7px; ">TransactionType</th>' +
  //       '<th style="padding: 7px; ">Transaction No.</th>' +
  //       '<th style="padding: 7px;">Name</th>' +
  //       '<th style="padding: 7px; ">Quantity</th>' +
  //       '<th style="padding: 7px; ">Rate</th>' +
  //       '<th style="padding: 7px; ">AmountLine</th>' +
  //       '<th style="padding: 7px; ">Balance</th>' +
  //       "</tr></thead>";
  //     content += "<tbody>";

  //     // Loop for printing items based on endIndex
  //     for (let index = startIndex; index <= endIndex; index++) {
  //       if (index <= newData.length) {
  //         content +=
  //           "<tr>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           index +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           newData[index - 1].Customername +
  //           "</td>" +
  //           '<td style="font-size: 6px; padding: 7px;">' +
  //           moment(newData[index - 1].DATE).format('DD-MM-YYYY') +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           newData[index - 1].TransactionType +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           newData[index - 1].Transactionnumber +
  //           "</td>" +
  //           '<td style="font-size: 6px; ">' +
  //           newData[index - 1].Name +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           newData[index - 1].Quantity +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; text-align: right;">' +
  //           newData[index - 1].Rate +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           Number(newData[index - 1].Amountline).toFixed(2) +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           Number(newData[index - 1].Balance).toFixed(2) +
  //           "</td>" +
  //           "</tr>";
  //       }

  //       if (index % 25 == 0) {
  //         startIndex = startIndex + 25;
  //         endIndex = endIndex + 25;
  //         break;
  //       }
  //     }

  //     content += "</tbody>";
  //     content += "</table>";

  //     content +=
  //       '<div style="text-align: center; width: 560px">' +
  //       '<p style= "text-align: center; margin-top: 1rem; font-size: 9px; font-weight: bold;">' +
  //       i +
  //       "</p>" +
  //       "</div>";
  //   }

  //   // Printing page
  //   doc.html(content, {
  //     callback: function (pdf) {
  //       pdf.save("Sales-Customer-Details.pdf");
  //       setLoading(false);
  //     },
  //   });
  // };

  const aggFuncs = useMemo(() => {
    return {
      Amount: (params) => {
        console.log(params, "params");
        let sum = 0;
        params.data?.Amount.forEach((value) => (sum += Number(value)));
        return sum;
      },
    };
  }, []);

  const defaultColDef = {
    sortable: true,
  };

  const autoGroupColumnDef = {
    comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
      var res = valueA == valueB ? 0 : valueA > valueB ? 1 : -1;
      return res;
    },
    field: "athlete",
    sort: "asc",
  };

  const onGridReady = useCallback((params) => {
    setLoading(true);

    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/customerbalancedetail?startdate=${""}&enddate=${""}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData);
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
          setData(res.data.ResponseData);
          // setOpenBalance(res.data.ResponseData.OpenBalance);
        }
        data.Amount = parseInt(data.Amount, 10);
        data.Balance = parseInt(data.Balance, 10); // Convert to integer

        console.log("data.OpenBalance", data.OpenBalance);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  const totalFooterRow = {
    Customername: "Total",
    Amount: totalSum,
    Balance: totalbalance,
  };

  const augmentedData = [...responseData, totalFooterRow];

  const totalPages = Math.ceil(responseData.length / ITEMS_PER_PAGE);

  const onBtExport = () => {
    const workbook = XLSX.utils.book_new();

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(responseData);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `CustomerBalanceDetail_.xlsx`);
  };

  // const onBtPrint = () => {
  //   setLoading(true);
  //   var doc = new jsPDF("l", "pt", "a3");

  //   // Add the header
  //   let headerElement = document.querySelector("#header");
  //   let clonedHeader = headerElement.cloneNode(true);
  //   clonedHeader.style.fontSize = `10px`;
  //   clonedHeader.style.width = "560px";
  //   clonedHeader.style.marginLeft = "15rem";

  //   let content = "";
  //   let startIndex = 1;
  //   let endIndex = 15;

  //   for (var i = 1; i <= Math.ceil(data.length / 15); i++) {
  //     if (i == 1) {
  //       clonedHeader.style.marginTop = "2rem";
  //     }
  //     if (i > 1 && i < Math.ceil(data.length / 15)) {
  //       clonedHeader.style.marginTop = "19rem";
  //     }

  //     if (i == Math.ceil(data.length / 15)) {
  //       clonedHeader.style.marginTop = "7rem";
  //     }
  //     // Printing header
  //     content += " " + clonedHeader.outerHTML;

  //     // Printing table body
  //     content +=
  //       '<table style="font-size: 8px; margin-left: 2rem; margin-top: 2rem;  width: 1140px; border: 1px solid #f5f5f5">';
  //     content +=
  //       "<thead><tr style='margin-bottom: 5px'>" +
  //       '<th style="padding: 7px;">No</th>' +
  //       '<th style="padding: 7px;">CompanyName</th>' +
  //       '<th style="padding: 7px;">Date</th>' +
  //       '<th style="padding: 7px; ">TransactionType</th>' +
  //       '<th style="padding: 7px;">Num</th>' +
  //       '<th style="padding: 7px; text-align: right;">Amount</th>' +
  //       '<th style="padding: 7px; ">Balance</th>' +
  //       '<th style="padding: 7px; ">ModifiedDate</th>' +
  //       '<th style="padding: 7px; ">CreatedBy</th>' +
  //       '<th style="padding: 7px; ">ModifiedBy</th>' +
  //       '<th style="padding: 7px; ">BillingAddress</th>' +
  //       '<th style="padding: 7px; ">Email</th>' +
  //       '<th style="padding: 7px; ">Phone</th>' +
  //       '<th style="padding: 7px; ">Terms</th>' +
  //       '<th style="padding: 7px; ">VendorMessage</th>' +
  //       '<th style="padding: 7px; ">MemoDescription</th>' +
  //       '<th style="padding: 7px; ">DeliveryAddress</th>' +
  //       "</tr></thead>";
  //     content += "<tbody>";

  //     // Loop for printing items based on endIndex
  //     for (let index = startIndex; index <= endIndex; index++) {
  //       if (index <= data.length) {
  //         content +=
  //           "<tr>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           index +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           data[index - 1].CompanyName +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           moment(data[index - 1].Date).format('DD-MM-YYYY') +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           data[index - 1].TransactionType +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           data[index - 1].Num +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; text-align: right;">' +
  //           Number(data[index - 1].Amount).toFixed(2) +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           Number(data[index - 1].Balance).toFixed(2) +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           moment(data[index - 1].ModifiedDate).format('DD-MM-YYYY') +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           data[index - 1].CreatedBy +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           data[index - 1].ModifiedBy +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           data[index - 1].BillingAddress +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           data[index - 1].Email +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           data[index - 1].Phone +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           data[index - 1].Terms +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           data[index - 1].VendorMessage +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           data[index - 1].MemoDescription +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           data[index - 1].DeliveryAddress +
  //           "</td>" +
  //           "</tr>";
  //       }

  //       if (index % 15 == 0) {
  //         startIndex = startIndex + 15;
  //         endIndex = endIndex + 15;
  //         break;
  //       }
  //     }

  //     content += "</tbody>";
  //     content += "</table>";

  //     content +=
  //       '<div style="text-align: center; width: 560px;margin-left: 220px">' +
  //       '<p style= "text-align: center; margin-top: 1.3rem; font-size: 9px; font-weight: bold;">' +
  //       i +
  //       "</p>" +
  //       "</div>";
  //   }

  //   // Printing page
  //   doc.html(content, {
  //     callback: function (pdf) {
  //       pdf.output("dataurlnewwindow");
  //       setLoading(false);
  //     },
  //   });
  // };

  const downloadPDF = (rows, field) => {
    let newData = [];
    if (field === "selectedrow") {
      newData = rows.map((row) => row.original);
    } else if (field === "alldata") {
      newData = responseData;
    }

    console.log(newData, "newData");
    setLoading(true);
    var doc = new jsPDF("l", "pt", "a3");

    // Add the header
    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `10px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.marginLeft = "15rem";

    let content = "";
    let startIndex = 1;
    let endIndex = 15;

    for (var i = 1; i <= Math.ceil(newData.length / 15); i++) {
      if (i == 1) {
        clonedHeader.style.marginTop = "2rem";
      }
      if (i > 1 && i < Math.ceil(newData.length / 15)) {
        clonedHeader.style.marginTop = "19rem";
      }

      if (i == Math.ceil(newData.length / 15)) {
        clonedHeader.style.marginTop = "7rem";
      }
      // Printing header
      content += " " + clonedHeader.outerHTML;

      // Printing table body
      content +=
        '<table style="font-size: 8px; margin-left: 2rem; margin-top: 2rem;  width: 1140px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 7px;">No</th>' +
        '<th style="padding: 7px;">CustomerName</th>' +
        '<th style="padding: 7px;">CompanyName</th>' +
        '<th style="padding: 7px; ">Date</th>' +
        '<th style="padding: 7px;">ModifiedDate</th>' +
        '<th style="padding: 7px; text-align: right;">CreatedBy</th>' +
        '<th style="padding: 7px; ">ModifiedBy</th>' +
        '<th style="padding: 7px; ">Phone</th>' +
        '<th style="padding: 7px; ">BillingAddress</th>' +
        '<th style="padding: 7px; ">Email</th>' +
        '<th style="padding: 7px; ">TransactionType</th>' +
        '<th style="padding: 7px; ">Terms</th>' +
        '<th style="padding: 7px; ">VendorMessage</th>' +
        '<th style="padding: 7px; ">MemoDescription</th>' +
        '<th style="padding: 7px; ">DeliveryAddress</th>' +
        '<th style="padding: 7px; ">Num</th>' +
        '<th style="padding: 7px; ">DueDate</th>' +
        '<th style="padding: 7px; ">Amount</th>' +
        '<th style="padding: 7px; ">OpenBalance</th>' +
        '<th style="padding: 7px; ">Balance</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex
      for (let index = startIndex; index <= endIndex; index++) {
        if (index <= newData.length) {
          content +=
            "<tr>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            index +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].CustomerName +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].CompanyName +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            moment(newData[index - 1].Date).format("MM-DD-YYYY HH:mm:ss") +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].ModifiedDate +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; text-align: right;">' +
            newData[index - 1].CreatedBy +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            newData[index - 1].ModifiedBy +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            newData[index - 1].Phone +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            newData[index - 1].BillingAddress +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            newData[index - 1].Email +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            newData[index - 1].BillingAddress +
            '<td style="font-size: 7px; padding: 7px; ">' +
            newData[index - 1].Email +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            newData[index - 1].TransactionType +
            '<td style="font-size: 7px; padding: 7px; ">' +
            newData[index - 1].Terms +
            '<td style="font-size: 7px; padding: 7px; ">' +
            newData[index - 1].VendorMessage +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            newData[index - 1].MemoDescription +
            '<td style="font-size: 7px; padding: 7px; ">' +
            newData[index - 1].DeliveryAddress +
            '<td style="font-size: 7px; padding: 7px; ">' +
            newData[index - 1].Num +
            '<td style="font-size: 7px; padding: 7px; ">' +
            newData[index - 1].DueDate +
            '<td style="font-size: 7px; padding: 7px; ">' +
            newData[index - 1].Amount +
            '<td style="font-size: 7px; padding: 7px; ">' +
            newData[index - 1].OpenBalance +
            "</td>" +
            "</tr>";
        }

        if (index % 15 == 0) {
          startIndex = startIndex + 15;
          endIndex = endIndex + 15;
          break;
        }
      }

      content += "</tbody>";
      content += "</table>";

      content +=
        '<div style="text-align: center; width: 560px;margin-left: 220px">' +
        '<p style= "text-align: center; margin-top: 1.3rem; font-size: 9px; font-weight: bold;">' +
        i +
        "</p>" +
        "</div>";
    }

    // Printing page
    doc.html(content, {
      callback: function (pdf) {
        pdf.save("Customer_Balance_Details.pdf");
        setLoading(false);
      },
    });
  };

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  console.log(responseData, "responseData941");
  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row" style={{ marginTop: "5px" }}>
              <h3 className="page-title">Customer Balance Detail</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/report">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Customer Balance Detail
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3 ">
              <div className="form-group row">
                <label className="col-form-label col-md-5 form-label">
                  Report period
                </label>
                <div className="col-md-7">
                  <Select
                    options={reportdropdown}
                    defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    //  value={selectedDate}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            <div className="col-sm-6 ">
              <div className="form-group row">
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
              </div>
            </div>

            <div className="col-sm-3">
              <button
                type="submit"
                className="btn btn-sm btn-primary pull-right "
                style={{ marginLeft: "auto" }}
                onClick={apicall}
              >
                Generate Report
              </button>
            </div>
          </div>

          {/* Receipt */}

          <div className="card mt-5">
            <div className="card-body">
              <div className="container">
                <div className="col-md-12 text-center " id="header">
                  <h2>SonarPos</h2>
                  <h6 className="fw-bold">Customer Balance Detail</h6>
                  <div className="row mb-2">
                    {/* <h6> Date: {new Date().toLocaleDateString()}</h6> */}
                    <h6>
                      Date: {startdate} - {enddate}
                    </h6>
                  </div>
                </div>
              </div>
              <hr />

              <div className="table-responsive">
                <div className="table mt-3"></div>
                {/* <div className="button">
                  <button
                    onClick={onBtExport}
                    className="btn btn-sm btn-outline-dark  m-1"
                    // style={{ marginBottom: '5px',marginLeft: "5px", fontWeight: 'bold' }}
                  >
                    <i class="fas fa-file-excel me-2 lg"></i>
                    Export to Excel
                  </button>
                  <button
                    onClick={downloadPDF}
                    className="btn btn-sm btn-outline-dark  m-1"
                    // style={{ marginBottom: '5px',marginLeft: "5px", fontWeight: 'bold' }}
                  >
                    <i class="fas fa-file-export me-2 lg"></i>
                    Export to Pdf
                  </button>
                  <button
                    className="btn btn-sm btn-outline-dark  m-1"
                    onClick={onBtPrint}
                  >
                    {" "}
                    <i class="fas fa-print me-2 lg"></i>Print
                  </button>
                </div> */}
                {/* <div
                  className="ag-theme-alpine"
                  style={{ height: "100vh", width: "100%" }}
                >
                  <AgGridReact
                    rowData={responseData}
                    columnDefs={columnDefs}
                    aggFuncs={aggFuncs}
                    defaultColDef={defaultColDef}
                    autoGroupColumnDef={autoGroupColumnDef}
                    columnTypes={columnTypes}
                    rowGroupPanelShow={'always'}
                    onGridReady={onGridReady}
                  ></AgGridReact>
                </div> */}

                <div>
                  <MaterialReactTable
                    muiTableContainerProps={{
                      sx: { maxHeight: "fit-content" },
                    }}
                    columns={columns}
                    data={data}
                    enableColumnResizing
                    enableGrouping
                    enableStickyHeader
                    enableStickyFooter
                    enableRowSelection
                    enableColumnOrdering
                    initialState={{
                      density: "compact",
                      expanded: true, //expand all groups by default
                      // grouping: [""], //an array of columns to group by by default (can be multiple)
                      pagination: { pageIndex: 0, pageSize: 25 },
                      sorting: [{ id: "state", desc: false }], //sort by state by default
                    }}
                    // muiToolbarAlertBannerChipProps={{ color: "primary" }}
                    // muiTableContainerProps={{ sx: { maxHeight: 700 } }}
                    muiTablePaginationProps={{
                      rowsPerPageOptions: [25, 50, 100, 300, 500],
                    }}
                    manualFiltering
                    manualPagination
                    manualSorting
                    muiToolbarAlertBannerProps={
                      isError
                        ? {
                            color: "error",
                            children: "Error loading data",
                          }
                        : undefined
                    }
                    // onColumnFiltersChange={setColumnFilters}
                    onGlobalFilterChange={setGlobalFilter}
                    onPaginationChange={setPagination}
                    onSortingChange={setSorting}
                    rowCount={rowCount}
                    state={{
                      // columnFilters,
                      globalFilter,
                      isLoading,
                      pagination,
                      showAlertBanner: isError,
                      showProgressBars: isRefetching,
                      sorting,
                    }}
                    renderTopToolbarCustomActions={({ table }) => (
                      <Box
                        sx={{
                          display: "flex",
                          gap: "1rem",
                          p: "0.5rem",
                          flexWrap: "wrap",
                        }}
                      >
                        <Button
                          size="small"
                          color="primary"
                          //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                          onClick={onBtExport}
                          startIcon={<FileDownloadIcon />}
                          variant="contained"
                        >
                          Export All In Excel
                        </Button>
                        <Button
                          size="small"
                          disabled={
                            !table.getIsSomeRowsSelected() &&
                            !table.getIsAllRowsSelected()
                          }
                          //only export selected rows
                          onClick={() =>
                            handleExportRows(table.getSelectedRowModel().rows)
                          }
                          startIcon={<FileDownloadIcon />}
                          variant="contained"
                        >
                          Export Selected Rows in Excel
                        </Button>
                        <Button
                          size="small"
                          color="primary"
                          //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                          onClick={() => downloadPDF("", "alldata")}
                          startIcon={<FileDownloadIcon />}
                          variant="contained"
                        >
                          Export All In Pdf
                        </Button>
                        <Button
                          size="small"
                          disabled={
                            !table.getIsSomeRowsSelected() &&
                            !table.getIsAllRowsSelected()
                          }
                          //only export selected rows
                          onClick={() =>
                            downloadPDF(
                              table.getSelectedRowModel().rows,
                              "selectedrow"
                            )
                          }
                          startIcon={<FileDownloadIcon />}
                          variant="contained"
                        >
                          Export Selected Rows in Pdf
                        </Button>
                        {/* <Button
                          size="small"
                          onClick={() =>
                            // setPagination({ ...pagination, pageSize: totalRows })
                            setPagination({
                              ...pagination,
                              pageIndex: 0,
                              pageSize: rowCount,
                            })
                          }
                          variant="contained"
                        >
                          Get All Data
                        </Button> */}
                      </Box>
                    )}
                  />
                </div>
              </div>
              {/* <div className="row">
                <div className="col-md-12 text-center">
                  <h6>
                    {" "}
                    {currentDate.toLocaleString()} &nbsp;GMT Time: {hours}:
                    {minutes}
                  </h6>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerBalanceDetail;
